import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";
import { useI18n } from "@/context/I18nContext";

/**
 * Shows rendered Impressum HTML (from POST /legal-html-templates/render-preview)
 * in a sandboxed iframe — the template author's markup/inline styles must
 * never reach the app shell's own DOM/CSS. Used by both the Legal HTML Editor
 * page and the Legal Pages "Preview" button.
 */
export function TemplatePreviewDialog({ open, onOpenChange, html, loading, subtitle }) {
  const { t } = useI18n();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="template-preview-dialog">
        <DialogHeader>
          <DialogTitle>{t("templatePreview.title")}</DialogTitle>
          {subtitle && <p className="font-mono text-[10px] text-muted-foreground">{subtitle}</p>}
        </DialogHeader>
        {loading ? (
          <Skeleton className="h-96 w-full" data-testid="template-preview-loading" />
        ) : (
          <iframe
            title="impressum-preview"
            data-testid="template-preview-frame"
            srcDoc={html || ""}
            sandbox=""
            className="h-96 w-full rounded-md border border-border bg-white"
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
